import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-go-back-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './go-back-button.component.html',
  styleUrls: ['./go-back-button.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoBackButtonComponent {
  // Input to control button mode
  mode = input<'back' | 'dashboard'>('back');
  label = input<string>('');

  // Output events
  goBack = output<void>();
  goDashboard = output<void>();

  onClick(): void {
    if (this.mode() === 'dashboard') {
      this.goDashboard.emit();
    } else {
      this.goBack.emit();
    }
  }

  getButtonText(): string {
    if (this.label()) return this.label();
    return this.mode() === 'dashboard' ? 'Go to Dashboard' : 'Go Back';
  }

  getIcon(): string {
    return this.mode() === 'dashboard' ? 'pi-home' : 'pi-arrow-left';
  }
}
